import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DocumentRegular from './document-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DocumentRegular {...validProps} />;
}
SvgComponent.iconName = 'documentRegular';

export const DocumentRegularIcon = svgIconWrapper(SvgComponent);
